import React, {
  useEffect,
  useState
}                                 from 'react';
import { useTranslation }         from 'react-i18next';
import { historyPropType }        from '~/config/routerPropTypes';
import Paper                      from '~/components/Paper';
import ReceiptIcon                from '@material-ui/icons/Receipt';
import Request                    from '~/providers/Request';
import GridContainer              from '~/components/GridContainer';
import GridItem                   from '~/components/GridItem';
import InputShow                  from '~/components/InputShow';
import moment                             from 'moment';
import partnerStatusEnum from '~/enums/partnerStatusEnum';
import { packageOptions } from '~/config/customQuery/packageBillingConfig';
import dig from 'object-dig';

function ShowPackBilling({history}) {
  const [ record, setRecord] = useState({});
  const [loading, setLoading] = useState(true);
  const { id } = history.location.route.getParams();
  const [billingStatus, setBillingStatus] = useState({});
  const { t } = useTranslation();
  const trAttr = (attr) => t(`packageBilling.attributes.${attr}`);

  useEffect(() => {
    setLoading(true);
    Request.get(`/admin/package_billings/${id}`, {})
    .then(response => {
      setLoading(false);
      setRecord( response.data );
    })
    .catch( e => {
      console.error(e);
      setLoading(false);
    });
  }, []);

  useEffect(() => {
    if(record.id){
      Request.get(`/admin/users/check_package_billing/${record.id}`, {}, {normalizeJSON: false})
        .then( response => {
          setBillingStatus(response);
        })
        .catch( e => {
          console.error(e);
        });
    }
  }, [record]);

  return (
    <>
    <Paper
      Icon={ReceiptIcon}
      iconColor='blue'
      title={t('packageBilling.defSingular')}
      loading={ loading }
    >
          <GridContainer>
            <GridItem xs={8} md={12}>
              <GridContainer>
                <GridItem xs={12} md={4}>
                  <InputShow
                    value={moment(record.transaction_at).format('DD/MM/YYYY HH:mm:ss')}
                    label={trAttr('transaction_at')}
                  />
                </GridItem>
                <GridItem xs={12} md={4}>
                  <InputShow
                    value={record.transaction_id}
                    label={trAttr('transaction_id')}
                  />
                </GridItem>
                <GridItem xs={12} md={4}>
                  <InputShow
                    value={record.store}
                    label={trAttr('store')}
                  />
                </GridItem>
              </GridContainer>
              <GridContainer>
                <GridItem xs={12} sm={3}>
                  <InputShow
                    value={record.origin}
                    label={trAttr('origin')}
                  />
                </GridItem>
                <GridItem xs={12} sm={3}>
                  <InputShow
                    value={partnerStatusEnum().objects()[record.partner_status]}
                    label={trAttr('partner_status')}
                  />
                </GridItem>
                <GridItem xs={12} sm={3}>
                  <InputShow
                    value={packageOptions[dig(record, 'package', 'type')]}
                    label={trAttr('pack_type')}
                  />
                </GridItem>
                <GridItem xs={12} sm={3}>
                  <InputShow
                    value={dig(record, 'package', 'resources_size')}
                    label={trAttr('resources_size')}
                  />
                </GridItem>
                <GridItem xs={12} sm={3}>
                  <InputShow
                    value={record.partner}
                    label={trAttr('partner')}
                    type={'object'}
                    digObject={['name']}
                  />
                </GridItem>
              </GridContainer>
              <GridContainer>
                <GridItem xs={12}>
                  <div style={{minWidth: 680, width: '100%', textAlign: 'center'}}>
                      { !billingStatus && <p>{t('packageBilling.extras.loading')}</p> }
                      { billingStatus &&
                        <>
                          <p><strong>{t('packageBilling.extras.active_store')}:</strong> {billingStatus.exists ? 'SIM' : 'NÃO'}</p>
                          <p><strong>{t('packageBilling.extras.state_store')}:</strong> {billingStatus.autoRenew}</p>
                          <p><strong>{t('packageBilling.extras.validity_store')}:</strong> {billingStatus.validade}</p>
                          <div style={{width: '100%'}}>
                            <textarea style={{width: '100%'}} rows={40} value={ JSON.stringify(billingStatus.result, undefined, 4) } />
                          </div>
                        </>
                      }
                    </div>
                </GridItem>
              </GridContainer>
            </GridItem>
          </GridContainer>
      </Paper>
    </>
  );
}

ShowPackBilling.propTypes={
  history: historyPropType,
};

export default ShowPackBilling;
